//Library Imports
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";

//Local Imports
import EditionCard from "modules/Campaigns/Shared/EditionCard";
import { getQueryCampaignId } from "modules/EmailBrowser/utils";
import { IVersion } from "modules/Campaigns/interfaces";
import { getScheduledEmails, resetAll } from "../actions";

//Style Imports
import styled from "styled-components";
import EditionsList from "./EditionsList";
import { EMAIL_TYPE_MAP } from "constants/index";
interface IScheduledEditions {
  isSearch?: boolean;
  previousSentSearch?: string;
  emailType?: any;
  user?: any;
  showTitle?: boolean;
  removePagination?: boolean;
  noEmptyMessage?: boolean;
  scheduledStyle?: boolean;
  date?: any;
}

const DEFAULT_PAGE_LIMIT = 20; //* later on api hits

const ScheduledEditions = (props: IScheduledEditions) => {
  const {
    isSearch,
    previousSentSearch,
    emailType,
    user,
    showTitle,
    removePagination,
    noEmptyMessage,
    scheduledStyle,
    date,
  } = props;
  //Others
  const assetType: any = useSelector((state: RootState) => state.assetDetails.assetType);
  const campaignId = getQueryCampaignId();
  const [firstTime, setFirstTime] = useState(true);

  //Scheduled Editions
  const scheduledEditions: IVersion[] = useSelector((state: RootState) => state.emails?.scheduledEmails?.data);

  const scheduledEditionsLoading = useSelector((state: RootState) => state.emails?.scheduledEmails?.loading);

  const hasMoreScheduled = useSelector((state: RootState) => state.emails?.hasMoreScheduled);

  const searchSentLoading: boolean = useSelector((state: RootState) => state.assetDetails.searchSentLoading);
  const getPagination = (isFirstLoad = false) => {
    let offset = 0;
    if (!isFirstLoad) {
      offset = scheduledEditions.length;
    }
    let limit = DEFAULT_PAGE_LIMIT; //update to 4
    return {
      ...(removePagination ? {} : { offset, limit }),
      asset_id: campaignId,
      // ...(date && !isSearch ? date : {}),
    };
  };

  const loadMore = () => {
    if (!scheduledEditionsLoading) {
      getScheduledEmails(campaignId, {
        ...getPagination(),
        ...(isSearch ? { search_term: previousSentSearch } : {}),
        ...(user.value === "default" ? {} : { user_id: user.value }),
        ...(EMAIL_TYPE_MAP[emailType.value] === "" ? {} : { email_type: EMAIL_TYPE_MAP[emailType.value] }),
      });
    }
  };

  useEffect(() => {
    if (firstTime) {
      getScheduledEmails(campaignId, {
        ...getPagination(scheduledEditions.length < 1 ? true : false),
        ...(isSearch ? { search_term: previousSentSearch } : {}),
        ...(user.value === "default" ? {} : { user_id: user.value }),
        ...(EMAIL_TYPE_MAP[emailType.value] === "" ? {} : { email_type: EMAIL_TYPE_MAP[emailType.value] }),
      });
      setFirstTime(false);
    }
  }, []);

  useEffect(() => {
    if (!firstTime) {
      resetAll();
      getScheduledEmails(campaignId, {
        ...getPagination(true),
        ...(user.value === "default" ? {} : { user_id: user.value }),
        ...(EMAIL_TYPE_MAP[emailType.value] === "" ? {} : { email_type: EMAIL_TYPE_MAP[emailType.value] }),
        ...(previousSentSearch && previousSentSearch.length > 0 ? { search_term: previousSentSearch } : {}),
      });
    }
  }, [user, emailType]);
  return (
    <>
      {scheduledEditions?.length > 0 && showTitle && (
        <HeadingWrapper className="d-flex flex-row justify-content-between align-items-center">
          <h3 className={"campaign-dashboard-heading margin-left-0"}>Scheduled Emails</h3>
        </HeadingWrapper>
      )}
      <>
        <EditionsList
          editionsLength={scheduledEditions.length}
          loadMore={loadMore}
          hasMore={hasMoreScheduled}
          editionsLoading={scheduledEditionsLoading}
          editions={scheduledEditions}
          campaignId={campaignId}
          assetType={assetType}
          isSearch={isSearch}
          noEmailText={`No scheduled emails found.`}
          noSearchEmailText={`No scheduled emails found against your search`}
          searchSentLoading={searchSentLoading}
          isScheduled={true}
          showEmailStats={false}
          noEmptyMessage={noEmptyMessage}
          scheduledStyle={scheduledStyle}
          tabState={"scheduled"}
        />
      </>
    </>
  );
};

export default ScheduledEditions;

ScheduledEditions.defaultProps = {
  isSearch: false,
  showTitle: true,
  removePagination: true,
  user: { value: "default" },
  emailType: { value: "all" },
};

const HeadingWrapper = styled.div`
  margin: 3px 0px 18px 0 !important;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    margin-top: 13px !important;
  }
  .editions-text-styling {
    font-size: 22px !important;
  }
  .search-bar {
    height: 34px;
  }
`;
